import {
	fastCombobox,
	fastOption,
	fastTreeView,
	fastToolbar,
	fastCard,
	fastHorizontalScroll,
	fastSkeleton,
	fastMenu,
	fastMenuItem,
	fastTextField,
} from '@microsoft/fast-components';

export const horizontalScroll = fastHorizontalScroll();
export const treeView = fastTreeView();
export const toolbar = fastToolbar();
export const combobox = fastCombobox();
export const option = fastOption();
export const skeleton = fastSkeleton();
export const card = fastCard();
export const menu = fastMenu();
export const menuItem = fastMenuItem();
export const textField = fastTextField();
